
<template>
  <div>
    <ul class="share clearfix">
      <li @click="useqrcode">
        <img src="../assets/icon/icon_wechat.png">
      </li>
      <li @click="shareBtn(qzoneUrl)">
        <img src="../assets/icon/icon_zone.png">
      </li>
      <li @click="shareBtn(qqUrl)">
        <img src="../assets/icon/icon_qq.png">
      </li>
      <li @click="shareBtn(weiboUrl)">
        <img src="../assets/icon/icon_sina.png">
      </li>
    </ul>
    <div class="qrcode" v-show="isShow" @click="close">
      <canvas ref="canvas"></canvas>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  data () {
    return {
      qzoneUrl: '',
      qqUrl: '',
      weiboUrl: '',
      isShow: false
    }
  },
  watch: {
    share: {
      handler: function (n, o) {
        this.init()
      },
      deep: true
    }
  },
  methods: {
    init: function (config) {
      let url = this.URLencode(window.location.href)
      let title = config.title
      let pic = config.pic
      let desc = config.desc
      this.qzoneUrl = `http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}&title=${title}&site=山东消费网&pics=${pic}&summary=${desc}&desc=${desc}`
      this.qqUrl = `http://connect.qq.com/widget/shareqq/index.html?url=${url}&title=${title}&pics=${pic}&summary=${desc}`
      this.weiboUrl = `http://service.weibo.com/share/share.php?url=${url}&title=${title}&pic=${pic}`
    },
    URLencode (str) {
      return escape(str).replace(/\+/g, '%2B').replace(/\"/g, '%22').replace(/\'/g, '%27').replace(/\//g, '%2F').replace(/\#/g, '%23')
    },
    shareBtn (url) {
      window.open(url)
    },
    // 动态生成二维码
    useqrcode () {
      let url = window.location.href
      let canvas = this.$refs.canvas
      QRCode.toCanvas(canvas, url, function (error) {
        if (error) console.error(error)
        console.log('success!')
      })
      this.isShow = true
    },
    close () {
      this.isShow = false
    }
  }
}
</script>

<style lang="less" scoped>
.share{
  width: 240px;
  li{
    width: 25%;
    float: left;
    padding: 12.5% 0;
    position: relative;
    img{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 90%;
      height: 90%;
      object-fit: contain;
    }
  }
}
.qrcode{
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, .66);
  canvas{
    width: 320px;
    height: 320px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 10px;
    border-radius: 10px;
  }
}
</style>
